import { Flex } from '@chakra-ui/react'
import { FieldContentNode, ScalarContentNode } from '@helo/cms'
import { Deferred, pipe } from '@helo/utils'

import { Icon } from '../../../components/Icons/Icon'
import { Link } from '../../../components/Link/Link'
import { Tooltip } from '../../../components/Tooltip/Tooltip'
import { StringRenderer } from '../../../datatypes/String/StringRenderer'
import { CellRendererProps } from '../table.types'

export const StringCell = ({
  // value,
  contentNode,
  // colDef,
  isCellHover = true,
}: CellRendererProps<string | number | null> & {
  // colDef: TextDataType
  contentNode: FieldContentNode
  isCellHover?: boolean
}) => {
  const state = contentNode.state ?? {}

  // Merge state from both contentNode and contentNode.ofType
  const mergedContentNode: ScalarContentNode = {
    ...(contentNode.ofType as ScalarContentNode),
    state: pipe(
      contentNode.ofType?.state ?? {},
      Deferred.merge(contentNode.state ?? {}),
    ),
  }
  const defaultOptions = {
    size: 'small',
  }
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <StringRenderer
        // value={value as any}
        contentNode={mergedContentNode}
        // options={{ ...defaultOptions, ...colDef.options }}
        // context={colDef.context}
      />
      {state?.linkUrl &&
        contentNode.data &&
        !state?.linkDisableTabIcon &&
        isCellHover && (
          <Link
            to={state?.linkUrl}
            search={state?.linkUrlStorage}
            target="_blank"
          >
            <Tooltip label="Open Link in New Tab" placement="top">
              <Icon
                icon="ExternalLinkIcon"
                color="presets.turquoise.60"
                boxSize="16px"
                marginTop="-4px"
              />
            </Tooltip>
          </Link>
        )}
    </Flex>
  )
}
